import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';

@Component({
    selector: 'iw-shop-article-notification',
    standalone: false,
    templateUrl: './article-notification.component.html',
    styleUrls: ['./article-notification.component.scss']
})
export class ArticleNotificationComponent implements OnInit, AfterViewInit, OnChanges {
    @Output() isNotifications = new EventEmitter();
    @Input() notifications?: {
        category: string;
        validFrom?: Date;
        validTo?: Date;
    }[];

    _notifications: string = '';

    constructor() {
    }

    ngOnInit(): void {
        this.setNotifications();
    }

    ngOnChanges() {
        this.setNotifications();
    }

    setNotifications() {
        this._notifications = '';
        this.notifications?.map(notification => {
            if (!notification.validTo ||
                !notification.validFrom) {
                this._notifications = this._notifications + ' ' + notification.category;
            } else {
                if (new Date(notification.validFrom) <= new Date() &&
                    new Date(notification.validTo) >= new Date) {
                    this._notifications = this._notifications + ' ' + notification.category;
                }
            }

        });
        if (this._notifications.length > 0) {
            this.isNotifications.emit(true);
        }
    }

    ngAfterViewInit(): void {

    }

}
